<template>
  <div class="means" >
    <div class="means-title">
      <span>经营理念</span>
    </div>
    <div class="means-content">
      <div class="hope-right">
        <pre>{{MeanDes}}</pre>
      </div>
      <div class="hope-left">
        <img :src="'http://' + MeanPhoto" alt="">
        <div class="img-back"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CompanyMean",
    props:{

    },
    data(){
      return{
        Data:{},
        MeanPhoto:{},
        MeanDes:{},
      }
    },
    created() {
      this.GetData()
    },
    methods:{
      GetData(){
        this.$axios.get('/api/companyIntro/getById?id=1').then(res=>{

          this.Data=res.data.data
          // // this.ItemDes=this.Data.description;
          // // this.ItemImg=this.Data.introPhotoUrl;
          // // // this.CulturePhoto=this.Data.culturePhotoUrl;
          // this.HopePhoto=this.Data.visionPhotoUrl;
          // this.HopeDes=this.Data.visionDescription;
          this.MeanPhoto=this.Data.ideaPhotoUrl;
          this.MeanDes=this.Data.manageIdeaDescription;
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  .means{
    width: 74.5vw;
    margin: 0 auto;
    .means-title{
      margin: 30px 0;
      text-align: center;
      span{
        height: 32px;
        font-size: 32px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #333333;
        line-height: 48px;
        letter-spacing: 1px;
      }
    }
    .means-content{
      display: flex;
      justify-content: space-between;
      .hope-left{
        width: 33.2vw;
        margin-top: 10px;

        position: relative;
        z-index: 5;
        img{
          width: 90%;
          height: 36.1vh;
        }
        .img-back{
          width: 86%;
          height: 34.1vh;
          z-index: -60;
          opacity: 0.1;
          border: 11px solid #358ED7;
          position: absolute;
          top: 30px;
          left: 40px;
        }
      }
      .hope-right{
        width: 32vw;
        margin-top: 14vh;
        pre{
          width: 32vw;
          font-size: 21px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #333333;
          line-height: 32px;
          white-space: pre-wrap;
        }
      }
    }
  }
</style>